// @flow
// $FlowFixMe
import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { QUERIES } from "@/enums/queries";
import { globalQueryClient } from "queries/queryClient";
import type { ReportResponseProps } from "types/reports";

import type { TeamDetails } from "../../types/team_details";
import loadPreviewForm from "./services/loadPreviewForm";

export const useLoadPreviewForm = (
  id: string,
  teamDetails: ?TeamDetails,
  options: any = {},
  // $FlowFixMe
): UseQueryResult<ReportResponseProps, Error> => {
  return useQuery({
    queryKey: [QUERIES.PREVIEW_FORM, teamDetails, id],
    queryFn: () => loadPreviewForm(id, teamDetails),
    ...options,
  });
};

export const invalidateLoadPreviewForm = (
  id: string,
  teamDetails: ?TeamDetails,
) => {
  globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.PREVIEW_FORM, teamDetails, id],
    exact: false,
  });
};
